
import { Controller } from "stimulus";
import api from "utils/api";
import * as Diff2Html from 'diff2html';
import * as Diff from "diff";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [
      "diffView",
      "expandButton"
  ];
  static classes = [ "" ]
  static values = {
    expandState: Boolean
  };

  initialize() {
    this.defaultContextLength = 3;
  }

  drawDiffView = (context) => {
    const diff = Diff.createPatch(
        this.data.get("field-key"),
        this.data.get("parsed-before"),
        this.data.get("parsed-after"),
        "",
        "",
        {context: context}
    );

    const { hunks } = Diff.parsePatch(diff)[0];
    if (hunks[0]) {
      const { newLines, oldLines } = hunks[0];

      if ((newLines > this.defaultContextLength) || (oldLines > this.defaultContextLength)) {
        this.expandButtonTarget.classList.remove("hidden");
      }
    }

    this.diffViewTarget.innerHTML = Diff2Html.html(diff, {
      matching: "lines",
      drawFileList: false,
      highlight: true,
      outputFormat: "side-by-side",
    });
  }

  connect() {
    this.drawDiffView(this.defaultContextLength);
  }

  expandContext = (e) => {
    if (this.expandStateValue) {
      this.drawDiffView(this.defaultContextLength);
      this.expandStateValue = false;
      e.target.innerText = "펼쳐보기"
    } else {
      this.drawDiffView(Number.MAX_SAFE_INTEGER);
      this.expandStateValue = true;
      e.target.innerText = "접기"
    }
  }

  disconnect() {

  }
}